/**
 * Created by mac on 2/25/20
 */

const CardTable = TileTable;

CardTable.prototype.listMissed = function () {
    const openCard = Game.currentGame.open.getCurrentCard();
    if (!openCard) {
        return [];
    }

    return this.cards.filter((card) => card.canPlay(openCard));
};

CardTable.prototype.animateMissed = function () {
    this.listMissed().forEach((wrongCard) => {
        wrongCard.trigger("wrongMove");
    });
};

CardTable.prototype.getRandomOpenedCardsForAttack = function (amount) {
    const cardsToCollect = [];
    for (var i = 0; i < this.cards.length; i++) {
        if (this.cards[i].canBeAttacked() && this.cards[i].isOpen() && !this.cards[i].isNearToDestroy()) {
            cardsToCollect.push(this.cards[i]);
        }
    }

    if (cardsToCollect.length < amount) {
        for (i = this.cards.length - 1; i >= 0; i--) {
            if (this.cards[i].canBeAttacked() && !this.cards[i].isOpen() && !this.cards[i].isNearToDestroy()) {
                cardsToCollect.push(this.cards[i]);
            }
            if (cardsToCollect.length === amount) {
                break;
            }
        }
    }

    const resultCards = PseudoRandom.GET().shuffle(cardsToCollect).slice(0, amount);
    resultCards.forEach((card) => {
        card.setNearToDestroy();
    });
    return resultCards;
};

CardTable.prototype.cardsThatCanBeReplacedWithBoosters = function () {
    return this.cards.filter((card) => {
        const isRightMarks = card.marks.length === 0
            || (card.marks.length === 1 && ["mission", "coin"].indexOf(card.marks[0].type) !== -1);
        const skippedByTutorial = cleverapps.tutorial.isActive() && card.opened;
        return card.canBeReplacedWithBoosters() && isRightMarks && !skippedByTutorial;
    });
};

CardTable.prototype.cardsWithPossibilityOfPlacingUnderThem = function () {
    return PseudoRandom.GET().shuffle(this.cards.filter((card, cardIndex) => {
        const invalidCardType = card instanceof Wildcard || card instanceof DoubleCard || card instanceof StreakCard;
        const hasMagnet = card.marks.filter((mark) => mark.type === "magnet").length > 0;
        const hasCardOnTop = this.cards.filter((anotherCard, anotherCardIndex) => anotherCardIndex > cardIndex && anotherCard.containsAnyPoint(card, [
            {
                x: Card.WIDTH / 2,
                y: Card.HEIGHT / 2 + Card.GRID_XY + 2
            },
            {
                x: -Card.WIDTH / 2,
                y: Card.HEIGHT / 2 + Card.GRID_XY + 2
            }])).length > 0;

        return !invalidCardType && !hasCardOnTop && !hasMagnet;
    }));
};

CardTable.MAX_SCALE = 1.4;